import { useEffect } from 'react';
import { useProgress } from 'react-native-track-player';
import { PlaybackEvent, PlaybackEventEmitter } from '@annunciate/core';
export const useTrackPlayerProgress = () => {
    const { position, duration } = useProgress();
    useEffect(() => {
        PlaybackEventEmitter.emit(PlaybackEvent.PROGRESS_UPDATED, {
            position,
            duration,
        });
    }, [position, duration]);
};
//# sourceMappingURL=useTrackPlayerProgress.js.map